import { z } from "zod";

import {
  rowActivitiesTypeSchema,
  rowSkillsTypeSchema,
  updateActivitiesTypeSchema,
} from "@libs/schemas";

export const activitySchema = rowActivitiesTypeSchema.merge(
  z.object({
    skills: z
      .array(
        rowSkillsTypeSchema.pick({
          id: true,
          name: true,
          skill_set: true,
        }),
      )
      .optional()
      .catch([]),
  }),
);

export type ActivityType = z.infer<typeof activitySchema>;

export const updateActivityFormSchema = updateActivitiesTypeSchema.omit({
  id: true,
  created_at: true,
  updated_at: true,
});
export type UpdateActivityFormType = z.infer<typeof updateActivityFormSchema>;

const activityFilterSchema = z.object({
  search: z.string().default("").catch(""),
});
export type ActivityFilterType = z.infer<typeof activityFilterSchema>;

export const activitySearchParamsSchema = activityFilterSchema.extend({
  id: z.string().uuid().optional().catch(""),
});
